/**
 * A row is `{ key, icon, label, value }` (icon: a Material Icons ligature, as
 * InfoBubble uses). A section is a titled group of rows on a tab; a section
 * with no present rows is not drawn.
 */

/** Rows the payload actually carries — a missing value drops the row, never shows N/A. */
export const present = (rows) => rows.filter((row) => row.value !== undefined);

export const section = (key, rows, title) => ({ key, title, rows: present(rows) });
